import { Box, Button, HStack } from "@chakra-ui/react"
import { useState } from "react"
import { FormLabel } from "../../common/FormLabel"
import { Select } from "../../common/Select"

const manualSessionScheduleTypes = [
    { value: 'ACTIVE', label: 'ACTIVE' },
    { value: 'INACTIVE', label: 'INACTIVE' }
]

export const ManualSessionSchedule = ({ schedule, onSave }) => {
    const [initialState, setInitialState] = useState(undefined)

    return (
        <Box display="flex" flexDir="column" alignItems="center" justifyContent="center">
            <HStack>
                <FormLabel margin={0}>Initial state</FormLabel>
                <Select
                    options={manualSessionScheduleTypes}
                    onChange={setInitialState}
                />
            </HStack>
            <Button
                width="fit-content"
                mt={4}
                onClick={() => onSave({
                    "@ManualSessionScheduleCfg" : {
                        initialState: {
                            "@ManualSessionSchedule": initialState.value
                        }
                    }
                })}
                isDisabled={!initialState}
            >
                ADD
            </Button>
        </Box>
    )
}